import   React from 'react'

import './Gallary.css'
import r1 from '../ProImg/r1.png'
import r2 from '../ProImg/r2.png'
import r3 from '../ProImg/r3.png'
import r4 from '../ProImg/r4.png'
import r5 from '../ProImg/r5.png'
import r6 from '../ProImg/r6.png'
import r14 from '../ProImg/r14.png'
import Header from '../Header'
import Footer from '../Footer'
import ScrollButtons from '../ScrollButtons'
import CardF from './CardF'



export default function Rooms() {
 
  return (
  <div>
<Header/>
<CardF/>
<ScrollButtons/>
<div className='container-fluid' id>
  
{/* Card  Start*/}


{/* Card End */}

 
   {/* Sagar Sir Code............................. */}
<div className='row mt-5'>
  <div className='col-sm-12'>
    <h1>Room Collection</h1>
  </div>
</div>
  <div className="row mt-5 m-0 p-0">
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
    <a href="#" className="room">
      
      <img src={r6} className="d-block w-100" alt="..."height={'255px'}   style={{borderRadius:'20px'}}/>
      
      <div className="p-3 text-center room-info">
        <h2>Single Room</h2>
        <span className="text-uppercase letter-spacing-1">90$ / per night</span>
      </div>
    </a>
  </div>
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
    <a href="#" className="room">
     
      <img src={r2} className="d-block w-100" alt="..."height={'255px'}  style={{borderRadius:'20px'}}/>
      
      <div className="p-3 text-center room-info">
        <h2>Family Room</h2>
        <span className="text-uppercase letter-spacing-1">120$ / per night</span>
      </div>
    </a>
  </div>
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
    <a href="#" className="room">
     
      <img src={r14} className="d-block w-100" alt="..." style={{borderRadius:'20px'}} height={'255px'}/>
     
      <div className="p-3 text-center room-info">
        <h2>Child Room</h2>
        <span className="text-uppercase letter-spacing-1">250$ / per night</span>
      </div>
    </a>
  </div>
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
    <a href="#" className="room">
     
      <img src={r4} className="d-block w-100" alt="..."height={'255px'} style={{borderRadius:'20px'}}/>
      
      <div className="p-3 text-center room-info">
        <h2> Under Water Room</h2>
        <span className="text-uppercase letter-spacing-1" >90$ / per night</span>
      </div>
    </a>
  </div>
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
  <a href="#" className="room">
      
      <img src={r5} className="d-block w-100" alt="..." style={{borderRadius:'20px'}} height={'240px'}/>
     
      <div className="p-3 text-center room-info">
        <h2>Presidential Room</h2>
        <span className="text-uppercase letter-spacing-1">120$ / per night</span>
        
      </div>
      </a>
  </div>
  <div className="col-md-6 col-lg-4 mb-5" data-aos="fade-up">
    <a href="#" className="room">
      
      <img src={r1} className="d-block w-100" alt="..."height={'240px'} style={{borderRadius:'20px'}}/>
      
      <div className="p-3 text-center room-info">
        <h2>Couple Room</h2>
        <span className="text-uppercase letter-spacing-1">250$ / per night</span>
      </div>
    </a>
  </div>
</div>
{/* urv khilb klhtit; */}
{/* <div className='row'>
  <div className='col-sm-12'>
    <h1 className='text-center'>Room Collection</h1>
  </div>
</div> */}

{/* <div className='row mt-4'>
  <div className='col-sm-1'></div>
  <div className='col-sm-5'>
  <img src={r1} className="d-block w-100" alt="..." style={{borderRadius:'50px'}}/>
  </div>
  <div className='col-sm-5'>
  <h1 className='text-center'>Room</h1>
  <p className='text-center'>Hotel management courses cover a wide range of topics, including: 
Revenue management: The process of selling the right room to the right guest at the right price and time, while also being cost efficient 
Financial management: Includes budgeting, forecasting, revenue management, and cost control 
Marketing management: The goal of a hotel's marketing department is to promote the hotel and create a positive public image 
Food production: Includes advanced food production and quality food production 
Facility planning: Includes planning for the facilities of a hotel 
Front office operation: Includes front office management 
Principles of management: Includes the application of management principles in the hospitality industry 
Principles of accounting: Includes accounting principles </p>
  </div>
  <div className='col-sm-1'></div>
</div> */}

</div>
<Footer/>
</div>



  )
}
